<script lang="ts">
	import InputMain from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';
	import type { PeopleFiltersSchema } from '$src/utils/api/feed.util';

  export let detail: PeopleFiltersSchema['location'];
  export let isValid: boolean = true;

  $: isValid = detail?.length > 0;
</script>

<InputMain
  label="Location"
  bind:value={detail}
  caption="Filter by location"
  danger={!isValid}
  dangerMessage="Enter a location"
/>
